function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaypalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.046 17.998 c -1.276 0.001 -2.363 0.93 -2.562 2.19 l -4.257 27 c 0.198 -1.261 1.285 -2.19 2.562 -2.19 h 12.475 c 12.555 0 23.208 -9.159 25.155 -21.57 c 0.145 -0.927 0.227 -1.862 0.246 -2.8 c -3.191 -1.673 -6.938 -2.63 -11.045 -2.63 L 37.046 17.998 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,28,100)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.663 20.629 c -0.019 0.938 -0.101 1.873 -0.246 2.8 c -1.947 12.411 -12.601 21.57 -25.155 21.57 H 32.789 c -1.276 0 -2.364 0.928 -2.562 2.19 l -3.914 24.811 L 23.86 87.564 c -0.183 1.148 0.6 2.227 1.748 2.41 C 25.718 89.991 25.829 90 25.94 90 h 13.54 c 1.276 -0.001 2.363 -0.93 2.562 -2.19 l 3.566 -22.621 c 0.2 -1.261 1.287 -2.19 2.564 -2.19 h 7.972 c 12.555 0 23.208 -9.159 25.155 -21.57 c 1.382 -8.809 -3.054 -16.824 -10.636 -20.799 L 70.663 20.629 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,112,224)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.663 0 c -1.276 0 -2.364 0.928 -2.562 2.188 L 8.476 69.564 c -0.201 1.279 0.787 2.436 2.082 2.436 h 15.756 l 3.912 -24.811 l 4.257 -27 c 0.2 -1.261 1.286 -2.189 2.562 -2.19 h 22.572 c 4.108 0 7.855 0.958 11.045 2.63 C 70.882 9.329 61.558 0 48.738 0 L 21.663 0 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,48,135)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalLogo);
export default __webpack_public_path__ + "static/media/paypal-logo.72022e02a369c9d0191f158b4fa0537d.svg";
export { ForwardRef as ReactComponent };